import { useState } from 'react';
import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

export default function NewClouderModal() {
  const [isOpen, setIsOpen] = useState(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: 'center',
          margin: 0,
          width: 'calc(100% - 24px)',
        },
      }}
    >
      <DialogContent
        sx={{
          padding: '32px 16px',
        }}
      >
        <Box display="flex" justifyContent="center" mb={3}>
          <SentimentSatisfiedAltIcon sx={{ fontSize: 56, color: 'grey.500' }} />
        </Box>

        <Typography variant="h5" fontWeight={400} mb={3} gutterBottom>
          ¡Bienvenido/a, Clouder!
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          Al ser un Clouder nuevo, esta vez puedes tomar rutas de hasta{' '}
          <strong>30 pedidos</strong>.
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={4}>
          Si quieres acceder a rutas más grandes, escríbenos al soporte y te
          ayudamos.
        </Typography>

        <Button fullWidth variant="contained" onClick={closeModal}>
          Entendido
        </Button>
      </DialogContent>
    </Dialog>
  );
}
